import { useEffect } from 'react';
import apiService from '../../services/apiService';

// #529 (Scheibe 4 aus #313): Abgleich der Tickets mit dem Kalender im
// Hintergrund -- alle 60 s, solange die Seite sichtbar ist, und die Reparatur
// verwaister Planungen einmal beim Anmelden und danach alle 10 Minuten. Laedt
// die Tickets nur neu, wenn sich etwas geaendert hat. Code unveraendert aus
// Dashboard.js uebernommen.
//
// Das Sync-Intervall haengt an manualRefreshTickets und startet mit ihm neu;
// die Reparatur haengt bewusst nur an currentUser.
export default function useTicketSync({ currentUser, manualRefreshTickets }) {
  // Start background calendar synchronization every 60 seconds
  useEffect(() => {
    const syncInterval = setInterval(async () => {
      // Only sync when page is visible
      if (document.visibilityState === 'visible') {
        try {
          const syncResult = await apiService.syncTicketCalendar();
          
          if (syncResult.success && (syncResult.results.removedPlanning > 0 || syncResult.results.updatedTimes > 0)) {
            // Automatically refresh tickets if changes were detected
            await manualRefreshTickets();
          }
        } catch (error) {
          console.error('Error during background synchronization:', error);
        }
      }
    }, 60000); // 60 seconds

    return () => clearInterval(syncInterval);
  }, [manualRefreshTickets]);

  // Run repair function: once on login + every 10 minutes (centralized here to avoid duplication)
  useEffect(() => {
    let repairInterval = null;

    const runRepair = async (isInitial = false) => {
      if (currentUser) {
        try {
          const logPrefix = isInitial ? '🔧 [LOGIN REPAIR]' : '🔧 [BACKGROUND REPAIR]';
          console.log(`${logPrefix} Running orphaned ticket repair...`);
          
          const repairResult = await apiService.repairOrphanedPlanning();
          if (repairResult.success) {
            console.log(`${logPrefix} Repair completed: ${repairResult.results.repairedTickets} tickets repaired`);
            if (repairResult.results.repairedTickets > 0) {
              // Refresh tickets to show repaired ones
              await manualRefreshTickets();
            }
          }
        } catch (error) {
          console.error('Error during ticket repair:', error);
        }
      }
    };

    // Run immediately once when user logs in (and component first mounts with user)
    if (currentUser) {
      runRepair(true);
      
      // Start 10-minute interval after initial repair
      repairInterval = setInterval(() => {
        // Only run if user is still logged in and page is visible
        if (currentUser && document.visibilityState === 'visible') {
          runRepair(false);
        }
      }, 600000); // 10 minutes
    }

    return () => {
      if (repairInterval) {
        clearInterval(repairInterval);
      }
    };
  }, [currentUser]); // Only depend on currentUser to avoid re-running on every manualRefreshTickets change
}
